/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Icon } from './Icon';

export namespace ExitIcon {
  export interface Props extends Icon.Props {}
}

export const ExitIcon: React.FC<Icon.Props> = ({ fill = 'none', stroke = undefined, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke={stroke}
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 5L11 5C11.55 5 12 4.55 12 4C12 3.45 11.55 3 11 3L4 3C2.9 3 2 3.9 2 5L2 19C2 20.1 2.9 21 4 21L11 21C11.55 21 12 20.55 12 20C12 19.45 11.55 19 11 19L4 19L4 5Z"
      fill="white"
    />
    <path
      d="M16.8 7.7925C16.41 8.1825 16.41 8.8025 16.8 9.1925L18.7 11.0925L9.5 11.0925C8.95 11.0925 8.5 11.5425 8.5 12.0925C8.5 12.6425 8.95 13.0925 9.5 13.0925H18.7L16.8 14.9925C16.41 15.3825 16.41 16.0025 16.8 16.3925C17.19 16.7825 17.81 16.7825 18.2 16.3925L21.79 12.8025C22.18 12.4125 22.18 11.7825 21.79 11.3925L18.2 7.7925C17.81 7.4025 17.19 7.4025 16.8 7.7925Z"
      fill="white"
    />
  </svg>
);
